import {Component, OnInit, Inject} from '@angular/core';
import { Router, NavigationEnd} from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import { DOCUMENT } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {OverlayContainer} from "@angular/cdk/overlay";

declare var $: any;

@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})

// TODO sales by product report https://seurestaurante.com/api/sales/reports/items?startDate=2018-08-01T00:00:00&endDate=2018-09-20T00:00:00
export class AppComponent implements OnInit {
    private subscription: Subscription;


    constructor( private router: Router, @Inject(DOCUMENT) private document: any, private translate: TranslateService,public overlayContainer: OverlayContainer) {
        this.translate.setDefaultLang('pt');
    }

    ngOnInit() {
        this.translate.use('pt');
        $.material.options.autofill = true;
        $.material.init();
        this.subscription = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            if (window.outerWidth > 991) {
                window.document.children[0].scrollTop = 0;
            }else{
                window.document.activeElement.scrollTop = 0;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts